import { render, staticRenderFns } from "./TestList.vue?vue&type=template&id=97b6baa0&scoped=true&"
import script from "./TestList.vue?vue&type=script&lang=ts&"
export * from "./TestList.vue?vue&type=script&lang=ts&"
import style0 from "./TestList.vue?vue&type=style&index=0&id=97b6baa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b6baa0",
  null
  
)

export default component.exports